export default {
  title: 'RESERVATION SETTINGS',
  items: {
    WebTimeBuffer: {
      label: 'WebForm New RSVP Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    AdminTimeBuffer: {
      label: 'Admin New RSVP Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    AppTimeBuffer: {
      label: 'App New RSVP Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    ReadyToGoTime: {
      label: 'Ready To Go Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    // CharterEnabled: {
    //   label: 'Charter Enabled',
    //   type: 'boolean'
    // },
    CharterEnabledBrands: {
      label: 'Brands Charter Enabled',
      type: 'string',
      unit: 'Brand IDs'
    },
    CharterMinDuration: {
      label: 'Charter Booking Min Duration',
      type: 'integer',
      unit: 'minutes'
    },
    CharterMinServiceTypeIds: {
      label: 'Charter Service Applied Min Duration',
      type: 'string',
      unit: 'Service IDs'
    },
    CharterMaxDuration: {
      label: 'Charter Booking Max Duration',
      type: 'integer',
      unit: 'minutes'
    },
    ReservationGapTime: {
      label: 'Time Gap Between Reservations in Runs',
      type: 'integer',
      unit: 'minutes'
    },
    ShowTotalInServiceSelect: {
      label: 'Show Full Price on Service select',
      type: 'boolean'
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/reservation-settings.js